/**
 * 素材市场路由配置
 */

export default {
    path: '/',
    name: 'MaterialMarket',
    component: () => import('@/views/material-market/material-market.vue'),
    redirect: '/application-center-home',
    children: [
        {
            path: 'application-center-home',
            name: 'ApplicationCenterHome',
            component: () => import('@/views/material-market/application-center-home.vue'),
            meta: {
                title: '素材市场首页',
                activeMenuName: 'MaterialMarket'
            }
        },
        {
            path: 'application-center-info',
            name: 'ApplicationCenterInfo',
            component: () => import('@/views/material-market/application-center-info.vue'),
            meta: {
                title: '素材搜索结果',
                activeMenuName: 'MaterialMarket'
            }
        },
        {
            path: 'my-resources-home',
            name: 'MyResourcesHome',
            component: () => import('@/views/my-resources/my-resources-home.vue'),
            meta: {
                title: '我的资源',
                activeMenuName: 'MyResourcesHome'
            }
        },
        {
            path: 'triton-master-home',
            name: 'TritonMasterHome',
            component: () => import('@/views/triton-master/triton-master-home.vue'),
            meta: {
                title: '创享达人',
                activeMenuName: 'TritonMasterHome'
            }
        }
    ]
};
